module.exports = __webpack_public_path__ + "img/ch48.17b26ca9.png";